import * as angular from 'angular';

class Voicemail {
  [x: string]: any;
  static $inject = ['FileUploader','$timeout','BASE_URL','$localStorage', 'Toast'];
  constructor(FileUploader, $timeout, BASE_URL, $localStorage, Toast) {
    this.uploader = new FileUploader({
      queueLimit: 1
    });
    this.$timeout = $timeout;
    this.BASE_URL = BASE_URL;
    this.$localStorage = $localStorage;
    this.FILE_SIZE_LIMIT = 50000000;
    this.toast = Toast;
  }

  $onInit() {
    this.uploader.method = this.method || "PUT";
    this.uploader.url = this.BASE_URL + this.url;
    this.uploader.headers = {
      'Account': this.$localStorage.currentAccount,
      'Authorization': 'Bearer ' + this.$localStorage.authToken
    };
    this.uploader.filters.push({
      name: 'Audiofilter', fn: (item) => {
        return item.type.endsWith('mp3') || item.type.endsWith('wav') || item.type.endsWith('ogg') || item.type.endsWith('mpeg');
      }
    }, {
      name: 'FileSize', fn: (item) => {
        return item.size < this.FILE_SIZE_LIMIT;
      }
    });
    this.uploader.onAfterAddingFile = this.getParseFileFunction();
    this.uploader.onSuccessItem = (fileItem, response, status, headers) => {
      this.refresh({ fileItem, response, status, headers });
    };
    this.uploader.onErrorItem = this.stop();

  }

  getParseFileFunction() {
    return () => {
      this.upload();
    }
  }

  upload() {
    this.uploader.uploadAll();
  }

  stop() {
    return () => {
      this.uploader.cancelAll();
      this.uploader.clearQueue();
      this.refresh();
      this.toast.error('INVALID_FILE')
    }
  }

  clickFileInput() {
    this.$timeout(function () {
      angular.element(`#${this.type}`)[0].click();
    }.bind(this), 0);
  }
}

export const FileDrop = {
  controller: Voicemail,
  template : require('./file-drop.html'),
  bindings: {refresh: "&", url: '<', type: '<', method: '<'}
};
